import { type RowAnchor } from './rowAnchor'

// One commentable number of the read-only plan tables: its row (RowAnchor)
// plus its column — 'target' on Overall Plan, a channel's org node id on
// Channel Breakdown, a quarter's start date on Channel Quarterly Breakdown.
export interface CellAnchor extends RowAnchor {
  column_key: string
  column_label: string
}

export function cellKey(c: Pick<CellAnchor, 'section' | 'anchor_id' | 'column_key'>): string {
  return `${c.section}:${c.anchor_id}:${c.column_key}`
}

export function quarterLabel(startDate: string): string {
  const [year, month] = startDate.split('-').map(Number)
  return `Q${Math.floor((month - 1) / 3) + 1} ${year}`
}

// "Halio × Shopee" names a cell by row and column. An Overall Plan row has
// one commentable number, so it reads "Halio target". Matches the server's
// Plan::ReviewCellComments.cell_label.
export function cellLabel(c: Pick<CellAnchor, 'section' | 'label' | 'column_label'>): string {
  return c.section === 'overall' ? `${c.label} target` : `${c.label} × ${c.column_label}`
}
